import { createFileRoute } from "@tanstack/react-router";
import CardTemplatesManagerDE from "@/pages/admin/CardTemplatesManagerDE";

export const Route = createFileRoute("/admin/card-templates")({
  component: CardTemplatesManagerDE,
});
